import {TOKENS} from "../../../constants/tokens";
import {HexMath} from "../../HexMath";
import {ConstructionAccessibility} from "../../ConstructionAccessibility";
import {QUARTERS_OF_DIFFERENT_CITIES_MIN_HEXES_BETWEEN} from "../../../constants/construction";

function getBlockedCells(citiesCache, constructionAccessibility, hexes, availableConstructionCells) {
  const blockedCells = new Set();
  const allQuarterCells = [];

  if (!citiesCache) {
    console.warn(`[getBlockedCells] citiesCache undefined`);
    return new Set();
  }

  // Собираем все существующие кварталы со всех городов всех игроков
  Object.values(citiesCache).forEach(playerCities => {
    playerCities.forEach(city => {
      // Добавляем центральный квартал города
      if (city.centralQuarter) {
        allQuarterCells.push(city.centralQuarter);
      }
      // Добавляем обычные кварталы города
      if (city[TOKENS.QUARTER] && Array.isArray(city[TOKENS.QUARTER])) {
        city[TOKENS.QUARTER].forEach(quarterKey => {
          allQuarterCells.push(quarterKey);
        });
      }
    });
  });

  // Для каждой ячейки с кварталом находим все ячейки на расстоянии до 2
  allQuarterCells.forEach(quarterKey => {
    // Получаем все ячейки достижимые за 2 хода, не проходя через горы
    const reachableCells = constructionAccessibility.findReachableCells(
      quarterKey,
      QUARTERS_OF_DIFFERENT_CITIES_MIN_HEXES_BETWEEN,
      hexes,
    );

    // Добавляем все найденные ячейки в заблокированные
    reachableCells.forEach(cellKey => {
      blockedCells.add(cellKey);
    });
  });

  // Оставляем только те заблокированные ячейки, которые входят в список доступных для строительства
  const availableSet = new Set(availableConstructionCells);
  const filteredBlockedCells = new Set();

  blockedCells.forEach(cellKey => {
    if (availableSet.has(cellKey)) {
      filteredBlockedCells.add(cellKey);
    }
  });

  return filteredBlockedCells;
}

/**
 * Рассчитывает ячейки, на которых запрещено строительство центрального квартала
 * Запрещены все ячейки на расстоянии до 2 ходов от любых уже существующих кварталов
 * Путь не может проходить через горы
 *
 * @param hexes
 * @param citiesCache
 * @param currentPlayerColor
 * @param {Array<string>} availableConstructionCells - ячейки доступные для строительства
 */
export const calculateBlockedConstructionCellsForCentralQuarter = (hexes, citiesCache, currentPlayerColor, availableConstructionCells) => {
  const hexMath = new HexMath(30, 'flat');
  const constructionAccessibility = new ConstructionAccessibility(hexMath);

  // У игрока может и не быть городов: например, у нейтрального «игрока» (см.
  // calculateBaseQuarterAllowedCells)
  let currentPlayerCitiesCache = {};
  let enemiesCitiesCache = {};
  Object.entries(citiesCache).forEach(([color, cities]) => {
    if (color === currentPlayerColor) {
      currentPlayerCitiesCache = {
        [color]: cities,
      }
    } else {
      enemiesCitiesCache[color] = cities;
    }
  });

  const blockedByEnemies = getBlockedCells(enemiesCitiesCache, constructionAccessibility, hexes, availableConstructionCells);
  const blockedBySelf = getBlockedCells(currentPlayerCitiesCache, constructionAccessibility, hexes, availableConstructionCells);

  return [new Set([...blockedBySelf, ...blockedByEnemies]), blockedBySelf, blockedByEnemies];
};
